import React from "react";
import { Outlet } from "react-router-dom";
import MenuBar from "../menu/Index";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";

const PrivateLayout = () => {
  return (
    <Box sx={{ display: "flex", minHeight: "100vh", maxWidth: "100vw", overflowX: "hidden" }}>
      {/* <CssBaseline /> */}
      <MenuBar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          maxWidth: "100%",
          overflowX: "hidden",
        }}
      >
        <Toolbar />
        <div className="py-1 px-4 content-background-clr">
          <Outlet />
        </div>
      </Box>
    </Box>
  );
};

export default PrivateLayout;
